import { useState, useEffect, useRef } from "react";

const useTooltipLogic = () => {
  const [tooltip, setTooltip] = useState({ visible: false, text: "", x: 0, y: 0 });
  const tableContainerRef = useRef(null);
  const tooltipRef = useRef(null);

  useEffect(() => {
    const updateTooltipPosition = () => {
      if (tooltip.visible && tooltipRef.current && tableContainerRef.current) {
        const targetElement = tooltipRef.current.targetElement;
        if (targetElement) {
          const rect = targetElement.getBoundingClientRect();
          const containerRect = tableContainerRef.current.getBoundingClientRect();
          const scrollX = tableContainerRef.current.scrollLeft;
          const scrollY = window.scrollY || window.pageYOffset;

          const tempTooltip = document.createElement("div");
          tempTooltip.style.visibility = "hidden";
          tempTooltip.style.position = "absolute";
          tempTooltip.innerHTML = tooltip.text?.replace(/\n/g, "<br/>");
          tempTooltip.style.padding = "5px 10px";
          document.body.appendChild(tempTooltip);
          const tooltipWidth = tempTooltip.offsetWidth;
          const tooltipHeight = tempTooltip.offsetHeight;
          document.body.removeChild(tempTooltip);

          let x = rect.left - containerRect.left + scrollX + rect.width + 10;
          let y = rect.top - containerRect.top + (rect.height - tooltipHeight) / 2;

          const containerWidth = tableContainerRef.current.offsetWidth;
          const windowHeight = window.innerHeight;

          if (x + tooltipWidth > containerWidth) {
            x = rect.left - containerRect.left + scrollX - tooltipWidth - 10;
          }
          if (y + tooltipHeight > windowHeight + scrollY) {
            y = windowHeight + scrollY - tooltipHeight - 10;
          }
          if (y < 0) y = 10;

          setTooltip((prev) => ({ ...prev, x, y }));
        }
      }
    };

    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener("scroll", updateTooltipPosition);
      window.addEventListener("scroll", updateTooltipPosition);
      return () => {
        container.removeEventListener("scroll", updateTooltipPosition);
        window.removeEventListener("scroll", updateTooltipPosition);
      };
    }
  }, [tooltip.visible]);

  const handleMouseEnter = (event, text) => {
    const targetElement = event.currentTarget;
    const rect = targetElement.getBoundingClientRect();
    const containerRect = tableContainerRef.current.getBoundingClientRect();
    const scrollX = tableContainerRef.current.scrollLeft;
    const scrollY = window.scrollY || window.pageYOffset;

    const tempTooltip = document.createElement("div");
    tempTooltip.style.visibility = "hidden";
    tempTooltip.style.position = "absolute";
    tempTooltip.innerHTML = text?.replace(/\n/g, "<br/>") || text;
    tempTooltip.style.padding = "5px 10px";
    document.body.appendChild(tempTooltip);
    const tooltipWidth = tempTooltip.offsetWidth;
    const tooltipHeight = tempTooltip.offsetHeight;
    document.body.removeChild(tempTooltip);

    let x = rect.left - containerRect.left + scrollX + rect.width + 10;
    let y = rect.top - containerRect.top + (rect.height - tooltipHeight) / 2;

    const containerWidth = tableContainerRef.current.offsetWidth;
    const windowHeight = window.innerHeight;

    if (x + tooltipWidth > containerWidth) {
      x = rect.left - containerRect.left + scrollX - tooltipWidth - 10;
    }
    if (y + tooltipHeight > windowHeight + scrollY) {
      y = windowHeight + scrollY - tooltipHeight - 10;
    }
    if (y < 0) y = 10;

    setTooltip({ visible: true, text, x, y });
    if (tooltipRef.current) tooltipRef.current.targetElement = targetElement;
  };

  const handleMouseLeave = () => {
    setTooltip({ visible: false, text: "", x: 0, y: 0 });
    if (tooltipRef.current) tooltipRef.current.targetElement = null;
  };

  return { tooltip, handleMouseEnter, handleMouseLeave, tableContainerRef, tooltipRef };
};

export default useTooltipLogic;